<pass-change>
  <div class="pass-change-title">パスワードの新規設定</div>
  <form class="pass-change-form" onsubmit="{ onFormSubmit }">
    <P>新しいパスワードを入力してください</P>
    <div class="form-group">
      <label class="form-label" for="password">新しいパスワード</label>
      <input class="form-control" type="text" id="password" name="password" required>
    </div>
    <div class="form-group">
      <label for="showPasswordCheck">
        <input type="checkbox" name="showPasswordCheck" id="showPasswordCheck" onchange="{ togglePassword }">
        <small>パスワードを表示する</small>
      </label>
    </div>

    <button class="pass-change-btn btn btn-blue">パスワードを変更する</button>
  </form>
  <script>
    import { serializeForm } from '@/common/utils/dom';
    export default {
      onMounted() {
        if (this.props.key) {
          this.props.passwordChangeCheck();
        }
      },

      togglePassword() {
        const passwordElement = this.$('#password');
        const type = passwordElement.getAttribute('type');
        passwordElement.setAttribute('type', type == 'password' ? 'text' : 'password');
      },

      onFormSubmit(e) {
        e.preventDefault();
        const data = serializeForm(e.target);
        this.props.changeUrl(data);
      }
    };
  </script>
  <style type="postcss">
    .pass-change-btn {
      width: 100%;
      margin-top: 16px;
    }
  </style>
</pass-change>